import { environment } from 'src/environments/environment';

/** Help article hub with setup steps for every supported AI tool. */
export const MCP_SETUP_GUIDE_URL =
  'https://support.timedoctor.com/knowledge/connecting-an-ai-application-to-time-doctor-mcp';

/** Public MCP Streamable HTTP endpoint for the current deployment. */
export function getMcpEndpointUrl(): string {
  const apiBase = environment.apiUrl.replace('{version}', '2.0').replace(/\/$/, '');
  return `${apiBase}/mcp/mcp`;
}

/** Lowercase slug safe for MCP server IDs (`[a-z0-9-]+`). */
export function slugifyCompanyId(companyId: string): string {
  const slug = companyId
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
  return slug || 'unknown';
}

/** Company-scoped MCP server id used in client config files. */
export function buildMcpServerId(companyId: string): string {
  return `timedoctor-${slugifyCompanyId(companyId)}`;
}
